import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhyChooseUs from './components/WhyChooseUs';
import SustainabilityGovernance from './components/SustainabilityGovernance';


function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <WhyChooseUs />
      <SustainabilityGovernance />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
